import {
  buildCollection,
  buildProperty,
} from "@firecms/core";

export type UserPublicProfile = {
  displayName?: string;
  avatarConfig?: Record<string, unknown>;
  teamLanguage?: string;
};

/** Schema for typed fetches (display names). Not shown in admin navigation. */
export const userPublicProfilesCollection = buildCollection<UserPublicProfile>({
  name: "User public profiles",
  singularName: "User public profile",
  description: "Public participant identity (display name and avatar).",
  id: "userPublicProfiles",
  path: "userPublicProfiles",
  icon: "Face",
  group: "Admin",
  hideFromNavigation: true,
  permissions: () => ({
    read: true,
    edit: true,
    create: false,
    delete: false,
  }),
  properties: {
    displayName: buildProperty({
      name: "Display name",
      dataType: "string",
    }),
    teamLanguage: buildProperty({
      name: "Team language",
      dataType: "string",
    }),
    avatarConfig: buildProperty({
      name: "Avatar config",
      dataType: "map",
      hideFromCollection: true,
    }),
  },
});
